"use strict";
import {appConfig} from "../config/app.conf";
import {cartoHelpers} from "@/helpers/cartoHelper";

export const refugiosService = {
    all,
    parkings
}


async function all() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let requestOptions = {
        method: 'GET',
        redirect: 'follow',
        headers: myHeaders
    };

    const rawData = await fetch(`https://api.${appConfig.api}/allRefuges/`, requestOptions)

    const request = await rawData.json()

    const content = await request

    const mapa =  cartoHelpers.fromApiToMapPoints(content.data)

    return mapa
}

async function parkings() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let requestOptions = {
        method: 'GET',
        redirect: 'follow',
        headers: myHeaders
    };

    const rawData = await fetch(`https://api.${appConfig.api}/allParkings`, requestOptions)

    const request = await rawData.json()

    const data = cartoHelpers.fromApiToMapPoints(request.data, 'parking')

    return data
}